'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shopcartAdd = undefined;

var _reduxActions = require('redux-actions');

var add = function add(obj) {
  return v12.shopcart.add(obj).then(function (data) {
    return { data: data };
  });
};

var shopcartAdd = exports.shopcartAdd = (0, _reduxActions.createAction)('SHOPCART_ADD', add);